import { connect } from 'react-redux';

import { ILikeButtonOwnProps, ILikeButtonStoreProps, LikeButton } from '.';
import { IAppState } from '../../../../store';

export const LikeButtonContainer = connect<ILikeButtonStoreProps, {}, ILikeButtonOwnProps>((state: IAppState) => ({
  user: state.user,
}))(LikeButton);
